import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { DatePicker, Flex, Input, Select, Typography } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { getTrainers } from 'src/store/Slices/DropDownSlice';
import { useDispatch, useSelector } from 'react-redux'
import { openNotification } from 'src/components/helpers/notification'
import { editTraining, getClientTrainings } from 'src/store/Slices/ClientsSlice'

const DeleteTraningModal = ({
    visible,
    setVisible,
    clientInfo,
    trainingInfo
}) => {

    // HELPERS
    const dispatch = useDispatch()
    const dateFormatList = ['DD.MM.YYYY'];

    const trainersList = useSelector(state => state.DropDownSlice.trainersList)

    // STATE
    const [startDate, setStartDate] = useState('')
    const [trainer, setTrainer] = useState()

    // FUNCTIONS
    const onClickDeleteTraning = () => {
        dispatch(editTraining({
            trainingPackId : trainingInfo?.id,
            trainingLeft : trainingInfo?.trainingsLeft - 1,
            trainer,
            trainingDate: dayjs(startDate, "DD.MM.YYYY").format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
        })).then(() => {
            dispatch(getClientTrainings({ clientId: clientInfo.id }))
        });

        setVisible(false);
    }

    

    useEffect(() => {
        if (trainingInfo) {
            setStartDate(trainingInfo?.startDate)
            setTrainer()
        }
    }, [visible])


    return (
        <>
            <CModal
                alignment="center"
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="VerticallyCenteredExample"
            >
                <CModalHeader>
                    <CModalTitle id="VerticallyCenteredExample">Удалить тренировку</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                        <>
                            <div>
                                <Typography.Title level={5}>Дата</Typography.Title>
                                <DatePicker
                                    style={{ width: '100%' }}
                                    format={'DD.MM.YYYY'}
                                    placement={'topRight'}
                                    onChange={(date, dateString) => { setStartDate(date) }}
                                    defaultValue={dayjs(startDate, dateFormatList)}
                                />
                            </div>

                            <div>
                                <Typography.Title level={5}>Тренер</Typography.Title>
                                <Select
                                    onClick={() => { dispatch(getTrainers()) }}
                                    style={{ width: '100%' }}
                                    options={trainersList?.data?.value}
                                    onChange={e => setTrainer(e)}
                                    value={trainer}
                                    placeholder='Выбрать'
                                    onSelect={(e, b) => {setTrainer(e)}}
                                />
                            </div>
                        </>
                    </Flex>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary text-light" onClick={() => {setVisible(false)}}>
                        Закрыть
                    </CButton>
                    <CButton color="primary text-light" onClick={onClickDeleteTraning}>Сохранить</CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}

export default DeleteTraningModal